var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgEHeatingValveDistr = function SvgEHeatingValveDistr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 684,
    height: 480,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 647,
    y: 326,
    width: 10,
    height: 28,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 652,
    y: 339,
    width: 10,
    height: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "644.86 326.51 659.14 326.5 652.01 338.99 644.86 326.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.28,327l-6.27,10.98-6.29-10.97h12.55M660,326h-16s8.01,14,8.01,14l7.99-14h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "652.01 341.01 659.14 353.49 644.86 353.5 652.01 341.01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652.01,342.02l6.27,10.98h-12.55s6.29-10.98,6.29-10.98M652.01,340l-8.01,14h16s-7.99-14-7.99-14h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 673,
    cy: 340,
    r: 11,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673,330c5.51,0,10,4.49,10,10s-4.49,10-10,10-10-4.49-10-10,4.49-10,10-10M673,329c-6.08,0-11,4.92-11,11s4.92,11,11,11,11-4.92,11-11-4.92-11-11-11h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M675.92,336.65v5.69h-.98v-1.88l.1-2.5-1.68,4.38h-.71l-1.68-4.38.1,2.51v1.88h-.98v-5.69h1.28l1.64,4.36,1.64-4.36h1.28Z"
  })))));
};
export default SvgEHeatingValveDistr;